import gql from 'graphql-tag';

import { getLanguageWithoutFormality } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ExtractCustomerPersonaFromEditor(
    $customerId: ID!
    $urls: [String!]
    $text: String
    $resourceId: ID
    $count: Int
    $language: String
  ) {
    extractCustomerPersonaFromEditor(
      customerId: $customerId
      urls: $urls
      text: $text
      resourceId: $resourceId
      count: $count
      language: $language
    ) {
      edges {
        node {
          ...CustomerPersona
        }
      }
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

export const extractCustomerPersonaFromEditor = ({
  urls,
  text,
  resourceId,
  count,
  language,
  customerId,
}) => {
  const variables = {
    urls,
    text,
    resourceId,
    count,
    language: getLanguageWithoutFormality(language),
    customerId,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  })
    .then(({ data }) => getSingleProp(data))
    .then((result) => {
      return unwrapEdges(result?.edges || []);
    });
};
